/* eslint-disable prefer-destructuring */
/* eslint-disable func-names */
import EDC from './globals';

EDC.Preloaders.Background = function (scene, list) {
  let bgIndexStr = '';
  let rndIndex = 0;
  if (list) {
    if (list.length === 1) {
      bgIndexStr = list[0];
    } else {
      rndIndex = Math.floor(Math.random() * list.length);
      bgIndexStr = list[rndIndex];
    }
  } else {
    rndIndex = 1 + Math.floor(Math.random() * (EDC.Settings.BackgroundsCount));
    bgIndexStr = rndIndex;
    if (rndIndex < 10) {
      bgIndexStr = `00${rndIndex}`;
    } else if (rndIndex >= 10 && rndIndex < 100) {
      bgIndexStr = `0${rndIndex}`;
    }
  }

  scene.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/backgrounds/');

  scene.load.image('background', `${bgIndexStr}.jpg`);
  scene.load.image('background-blur', `blur/${bgIndexStr}.jpg`);

  scene.load.setPath();
};

export default EDC.Preloaders.Background;
